var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { makeObservable, observable, action } from "mobx";
export class RuleExecutionDropDownState {
    constructor() {
        this.show = false;
        this.zindex = -1;
        this.top = 0;
        this.left = 0;
        this.dragging = false;
        this.execopt = "overwrite";
        this.executing = false;
        this.activecolid = "";
        this.activerowid = "";
        makeObservable(this);
    }
    setExecuting(executing) {
        this.executing = executing;
    }
    setZIndex(index) {
        this.zindex = index;
    }
    setDragging(drag) {
        this.dragging = drag;
    }
    setExecOpt(op) {
        this.execopt = op;
    }
    setTop(top) {
        this.top = top;
    }
    setLeft(left) {
        this.left = left;
    }
    setShow(show) {
        this.show = show;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], RuleExecutionDropDownState.prototype, "show", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RuleExecutionDropDownState.prototype, "zindex", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RuleExecutionDropDownState.prototype, "top", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RuleExecutionDropDownState.prototype, "left", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RuleExecutionDropDownState.prototype, "dragging", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], RuleExecutionDropDownState.prototype, "execopt", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RuleExecutionDropDownState.prototype, "executing", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], RuleExecutionDropDownState.prototype, "setExecuting", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], RuleExecutionDropDownState.prototype, "setZIndex", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], RuleExecutionDropDownState.prototype, "setDragging", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RuleExecutionDropDownState.prototype, "setExecOpt", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], RuleExecutionDropDownState.prototype, "setTop", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], RuleExecutionDropDownState.prototype, "setLeft", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], RuleExecutionDropDownState.prototype, "setShow", null);
